export default __webpack_public_path__ + "static/media/about-us-2.b772c213.svg";